export default __webpack_public_path__ + "static/media/Hot Object.e277167b.jpg";